/** Base URL for DB-stored image paths (e.g. `firms/fundednext.png`). */
export const IMAGE_BASE =
  process.env.NEXT_PUBLIC_IMAGE_BASE_URL?.replace(/\/$/, '') || '/uploads'

/**
 * Turn a DB path (e.g. `firms/ftmo.png`) or absolute URL into a usable src.
 */
export function resolveImageUrl(path) {
  if (!path?.trim()) return null
  if (/^https?:\/\//i.test(path)) return path

  const normalized = path.replace(/^\//, '')

  if (IMAGE_BASE.startsWith('http')) {
    return `${IMAGE_BASE}/${normalized}`
  }

  const prefix = IMAGE_BASE.startsWith('/') ? IMAGE_BASE : `/${IMAGE_BASE}`
  return `${prefix}/${normalized}`.replace(/\/+/g, '/')
}
